//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LabeledControlLayout from '@/components/shared/labeled-control-layout'
import CustomSwitch from '@/components/shared/custom-switch'
import {customerTypes} from '@/enums/customerTypes'
import {adminCodes} from '@/enums/adminSettings'
import {mapActions} from 'vuex'
export default {
  name: 'SignUp',
  components: {LabeledControlLayout, CustomSwitch},
  data: () => ({
    createCompany: false,
    signUpForm: {
      data: {
        company: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
      },
      emailRules: [
        (v) =>
          /.+@.+\..+/.test(v) ||
          'Please enter a valid email address!'
      ],
      rules: {
        required: (value) => !!value || 'This is a required field',
      },
      valid: false,
      rememberMe: false,
    },
  }),
  async mounted() {
    const defaultCustomerType = await this.fetchAdminSettingByCode(
      adminCodes.default_customer_type_on_registration
    )
    if (defaultCustomerType) {
      this.createCompany = defaultCustomerType.value === 'company'
    }
  },
  methods: {
    ...mapActions('backoffice/settings', ['fetchAdminSettingByCode']),
    async signUp() {
      if (this.$refs.signUpForm.validate()) {
        try {
          const response = await this.$axios.post('auth/register', {
            Email: this.signUpForm.data.email,
            Company: this.signUpForm.data.company,
            FirstName: this.signUpForm.data.firstName,
            LastName: this.signUpForm.data.lastName,
            Phone: this.signUpForm.data.phone,
            AutoGeneratePassword: true,
            CreateUser: true,
            CustomerTypeID: this.createCompany
              ? customerTypes.Company
              : customerTypes.Person,
          })

          if (response.status === 200) {
            this.$toast.success('Thank you for your registration, please check your email and log in with the user credentials we just sent you.')
            this.showLogin()
          } else {
            this.$toast.error(
              `There was an error registering the user! Error code: ${response.status}`
            )
          }
        } catch (err) {
          this.$toast.error('Error while signing up!')
        }
      }
    },
    showLogin() {
      this.$router.push('/user-login')
    },
  },
}
